import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollHandler = () => {
  const location = useLocation();

  useEffect(() => {
    // Check if there's a hash in the URL
    if (location.hash) {
      // Remove the # symbol
      const elementId = location.hash.substring(1);
      
      // Wait a bit for the page to render
      setTimeout(() => {
        const element = document.getElementById(elementId);
        if (element) {
          // Account for fixed navbar height
          const navbarHeight = 80; // Adjust based on your navbar height
          const elementPosition = element.getBoundingClientRect().top + window.scrollY;
          window.scrollTo({
            top: elementPosition - navbarHeight,
            behavior: 'smooth'
          });
          
          // Also set the active tab based on the section
          if (elementId === 'upsc-section') {
            // You might need to trigger the tab change - we'll handle this in HomePage
          }
        }
      }, 100);
    }
  }, [location]);

  return null;
};

export default ScrollHandler;